import { render, staticRenderFns } from "./PageDivider.vue?vue&type=template&id=e2f84e14&scoped=true"
import script from "./PageDivider.vue?vue&type=script&lang=js"
export * from "./PageDivider.vue?vue&type=script&lang=js"
import style0 from "./PageDivider.vue?vue&type=style&index=0&id=e2f84e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f84e14",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue
// module id = 269
// module chunks = 0